import { render, staticRenderFns } from "./LayoutContentHorizontalNav.vue?vue&type=template&id=060d1c93&scoped=true&"
import script from "./LayoutContentHorizontalNav.vue?vue&type=script&lang=js&"
export * from "./LayoutContentHorizontalNav.vue?vue&type=script&lang=js&"
import style0 from "./LayoutContentHorizontalNav.vue?vue&type=style&index=0&id=060d1c93&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "060d1c93",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VAppBarNavIcon } from 'vuetify/lib/components/VAppBar';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VImg } from 'vuetify/lib/components/VImg';
import { VOverlay } from 'vuetify/lib/components/VOverlay';
installComponents(component, {VAppBarNavIcon,VIcon,VImg,VOverlay})
